export const on = (
    el: Element | Window, 
    eventName: string, 
    callback: (event: Event) => void, 
    opts: boolean | AddEventListenerOptions = false
  ): void => {
    // Directly add the event listener if 'el' is an instance of Window or Element.
    // This check is sufficient for all standard use cases.
    if (el instanceof Window || el instanceof Element) {
      el.addEventListener(eventName, callback, opts);
    }
    // If there were specific conditions or additional logic needed,
    // ensure they are correctly scoped and apply only to appropriate types.
  };
  
  
  
  export const off = (
    el: Element | Window, 
    eventName: string, 
    callback: (event: Event) => void, 
    opts: boolean | EventListenerOptions = false
  ): void => {
    // Directly remove the event listener if 'el' is an instance of Window or Element.
    // This check is sufficient for all standard use cases.
    if (el instanceof Window || el instanceof Element) {
      el.removeEventListener(eventName, callback, opts);
    }
    // The incorrect branch has been removed for clarity and correctness.
  };
  